'use client';

import addToCartTrigger from '@coolblue-development/ga4-events/triggers/Wishlist/addToCartTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import type { WishlistProduct } from '@coolblue-development/next-wishlist';
import AddToCartButton from '@features/shared/AddToCartButton';

type Props = {
  product: WishlistProduct;
  index: number;
  totalIndices: number;
};

export default function TrackedAddToCartButton({ product, index, totalIndices }: Props) {
  const { trackEvent } = useAnalytics();

  const handleTracking = () => {
    trackEvent(
      addToCartTrigger({
        item_id: product.id,
        order_type: 'purchase',
        index: index,
        total_indices: totalIndices
      })
    );
  };

  return <AddToCartButton product={product} onClick={handleTracking} />;
}
